import { h, Component } from "preact";
import "./welcome.scss";

import WattpadIcon from "../icons/wattpad.svg";
import AO3Icon from "../icons/AO3Logo.svg";
import EPUBIcon from "../icons/epub.svg";
import Api from "../api";
import theme, { ThemeStates } from "../theme";

export interface WelcomeProps {}
interface WelcomeState {}
export class WelcomeComponent extends Component<WelcomeProps, WelcomeState> {
   current: ThemeStates;
   constructor(props: WelcomeProps) {
      super(props);
   }
   componentWillMount() {
      this.current = theme.active();
      theme.change(ThemeStates.LIGHT, false);
   }
   componentWillUnmount() {
      theme.change(this.current, false);
   }
   render(props: WelcomeProps, state: WelcomeState) {
      return (
         <div>
            <header class="header" style="border-bottom: 0">
               <a href="#" class="logo">
                  EBook Store
               </a>
               <span style=" position:absolute; right: 0;">
                  <a href={Api.loginUrl} class="login">
                     Sign In
                  </a>
               </span>
            </header>

            <div class="splash-container">
               <div class="splash">
                  <h1 class="splash-head">Ebook Store</h1>
                  <p class="splash-subhead">Keep your books in one place</p>
               </div>
            </div>

            <div class="content-wrapper">
               <div class="content">
                  <div class="container">
                     <div class="row">
                        <h2 class="content-head is-center">
                           Import from different locations:
                        </h2>
                     </div>
                     <div className="row provider-grid">
                        <div class="col-sm-12 col-md-4 col-lg-4 provider-item">
                           <img src={WattpadIcon} class="provider-image" />
                           <h2 class="provider-name">Wattpad</h2>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4 provider-item">
                           <img src={AO3Icon} class="provider-image" />
                           <h2 class="provider-name">AO3</h2>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4 provider-item">
                           <img src={EPUBIcon} class="provider-image" />
                           <h2 class="provider-name">Epub</h2>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}
